var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxtbiz-language-slot",
    { attrs: { "lang-key": "pc_biz_lbl_studytime" } },
    [
      _vm.isCanEdit
        ? [
            _c(
              "yxt-tooltip",
              {
                attrs: {
                  slot: "0",
                  disabled: _vm.canEditHours,
                  content: _vm.$t("pc_biz_lbl_noeditauth" /** 无编辑权限 */),
                },
                slot: "0",
              },
              [
                _c("yxt-input-number", {
                  staticClass: "mr4",
                  attrs: {
                    disabled: _vm.disabled || !_vm.canEditHours,
                    precision: 0,
                    step: 1,
                    max: 999,
                    min: 0,
                  },
                  model: {
                    value: _vm.minute,
                    callback: function ($$v) {
                      _vm.minute = $$v
                    },
                    expression: "minute",
                  },
                }),
              ],
              1
            ),
            _c(
              "yxt-tooltip",
              {
                attrs: {
                  slot: "1",
                  disabled: _vm.canEditHours,
                  content: _vm.$t("pc_biz_lbl_noeditauth" /** 无编辑权限 */),
                },
                slot: "1",
              },
              [
                _c("yxt-input-number", {
                  staticClass: "ml4 mr4",
                  attrs: {
                    disabled: _vm.disabled || !_vm.canEditHours,
                    precision: 0,
                    step: 1,
                    max: 59,
                    min: 0,
                  },
                  model: {
                    value: _vm.second,
                    callback: function ($$v) {
                      _vm.second = $$v
                    },
                    expression: "second",
                  },
                }),
              ],
              1
            ),
          ]
        : [
            _c("span", { attrs: { slot: "0" }, slot: "0" }, [
              _vm._v(_vm._s(_vm.minute)),
            ]),
            _c("span", { attrs: { slot: "1" }, slot: "1" }, [
              _vm._v(_vm._s(_vm.second)),
            ]),
          ],
      _c(
        "span",
        { staticClass: "color-gray-6", attrs: { slot: "2" }, slot: "2" },
        [_vm._v("\n    " + _vm._s(_vm.tipText) + "\n  ")]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }